export default __webpack_public_path__ + "static/media/twitter.81851682.svg";